import { InjectionToken, StaticProvider } from '@angular/core';

import { BaseApiConfig, EndpointParserFn } from '../../models/base-api-config.model';

export type ComplianceApiConfig = BaseApiConfig<{
  scanCreatorPosts: string;
  getRecords: string;
  updateStatus: string;
  getSummary: string;
  getComplianceHealth: string;
  getComplianceInfo: string;
  requestAudit: string;
  getJobStatus: EndpointParserFn;
  generateReport: string;
}>;

export const COMPLIANCE_API_CONFIG = new InjectionToken<ComplianceApiConfig>('COMPLIANCE_API_CONFIG');

export const provideComplianceApiConfig = (config: ComplianceApiConfig): StaticProvider => ({
  provide: COMPLIANCE_API_CONFIG,
  useValue: config,
});
